import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_5 = ["type", "id", "placeholder", "value", "required"]

interface Props {
  modelValue: string;
  label?: string; // Optional prop
  type?: string;
  id: string;
  placeholder?: string;
  icon?: string;
  required?: boolean;
}

// Define props

export default /*@__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    modelValue: {},
    label: {},
    type: {},
    id: {},
    placeholder: {},
    icon: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



// Define emits
const emit = __emit;

// Handle input
function handleInput(event: Event) {
  const target = event.target as HTMLInputElement;
  if (target) {
    const value = target.value;
    emit('update:modelValue', value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "form-label fw-bold d-block text-start"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.icon)
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: _ctx.type,
        id: _ctx.id,
        placeholder: _ctx.placeholder,
        class: "form-control",
        value: _ctx.modelValue,
        onInput: handleInput,
        required: _ctx.required || false
      }, null, 40, _hoisted_5)
    ])
  ]))
}
}

})